const SENSITIVE_KEYS = new Set([
  'code',
  'destination',
  'email',
  'formToken',
  'maskedDestination',
  'otpCode',
  'password',
  'pdfBytes',
  'recipientEmail',
  'refreshToken',
  'token',
  'zipBytes',
  'blob',
]);

const isPlainObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

export const sanitizeTelemetryPayload = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => sanitizeTelemetryPayload(item));
  }

  if (!isPlainObject(value)) {
    return value;
  }

  return Object.entries(value).reduce((accumulator, [key, entryValue]) => {
    if (SENSITIVE_KEYS.has(key)) {
      return accumulator;
    }

    accumulator[key] = sanitizeTelemetryPayload(entryValue);
    return accumulator;
  }, {});
};

export const getCorrelationIdFromResponse = (response) => {
  if (!response) return null;

  return (
    response.headers?.['x-correlation-id'] ||
    response.headers?.['X-Correlation-Id'] ||
    response.data?.correlationId ||
    response.data?.apiError?.correlationId ||
    response.correlationId ||
    null
  );
};

export const getCorrelationIdFromError = (error) => {
  if (!error) return null;

  return (
    getCorrelationIdFromResponse(error.response) ||
    error.response?.data?.correlationId ||
    error.response?.data?.apiError?.correlationId ||
    error.correlationId ||
    null
  );
};

const getTelemetrySink = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  if (typeof window.__CBM_TELEMETRY_SINK__ === 'function') {
    return window.__CBM_TELEMETRY_SINK__;
  }

  if (Array.isArray(window.__CBM_TELEMETRY_EVENTS__)) {
    return (event) => {
      window.__CBM_TELEMETRY_EVENTS__.push(event);
    };
  }

  return null;
};

export const trackSecurePackageEvent = (eventName, payload = {}) => {
  const event = {
    eventName,
    source: 'secure-package',
    timestamp: new Date().toISOString(),
    ...sanitizeTelemetryPayload(payload),
  };

  const sink = getTelemetrySink();
  if (sink) {
    sink(event);
  } else if (
    typeof process === 'undefined' ||
    process.env?.NODE_ENV !== 'test'
  ) {
    console.info('[secure-package telemetry]', event);
  }

  return event;
};
